/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StrategyDescription', 'model/StrategyExecutionExportSettings', 'model/StrategyExportItemSettings', 'model/StrategyBusinessReviewExportSettings', 'model/StrategyDescriptionReport', 'model/StrategicGoalMilestone'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StrategyDescription'), require('../model/StrategyExecutionExportSettings'), require('../model/StrategyExportItemSettings'), require('../model/StrategyBusinessReviewExportSettings'), require('../model/StrategyDescriptionReport'), require('../model/StrategicGoalMilestone'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyDescriptionApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StrategyDescription, root.ForStractionServiceApi.StrategyExecutionExportSettings, root.ForStractionServiceApi.StrategyExportItemSettings, root.ForStractionServiceApi.StrategyBusinessReviewExportSettings, root.ForStractionServiceApi.StrategyDescriptionReport, root.ForStractionServiceApi.StrategicGoalMilestone);
  }
}(this, function(ApiClient, StrategyDescription, StrategyExecutionExportSettings, StrategyExportItemSettings, StrategyBusinessReviewExportSettings, StrategyDescriptionReport, StrategicGoalMilestone) {
  'use strict';

  /**
   * StrategyDescription service.
   * @module api/StrategyDescriptionApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StrategyDescriptionApi. 
   * @alias module:api/StrategyDescriptionApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the strategyDescriptionAddPut operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategyDescription} body 
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.strategyDescriptionAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StrategyDescription/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionCopyGet operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionCopyGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * copy
     * @param {String} _4SAPIAppID 
     * @param {Integer} sourceStrategyID 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.copySubstrategies  (default to false)
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionCopyGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategyDescriptionCopyGet = function(_4SAPIAppID, sourceStrategyID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionCopyGet";
      }

      // verify the required parameter 'sourceStrategyID' is set
      if (sourceStrategyID == undefined || sourceStrategyID == null) {
        throw "Missing the required parameter 'sourceStrategyID' when calling strategyDescriptionCopyGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sourceStrategyID': sourceStrategyID,
        'copySubstrategies': opts['copySubstrategies']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategyDescription/copy', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionDeleteGet operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.deleteSubstrategies  (default to false)
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategyDescriptionDeleteGet = function(_4SAPIAppID, primaryKey, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling strategyDescriptionDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey,
        'deleteSubstrategies': opts['deleteSubstrategies']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategyDescription/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionEditAllPut operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StrategyDescription>} body 
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategyDescriptionEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategyDescription/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionEditPut operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategyDescription} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.updateSubStrategiesLabels  (default to false)
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategyDescriptionEditPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'updateSubStrategiesLabels': opts['updateSubStrategiesLabels']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategyDescription/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionExportCityOfHelsinkiMilestonesToExcelFilePut operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionExportCityOfHelsinkiMilestonesToExcelFilePutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * exportCityOfHelsinkiMilestonesToExcelFile
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategyExecutionExportSettings} body 
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionExportCityOfHelsinkiMilestonesToExcelFilePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.strategyDescriptionExportCityOfHelsinkiMilestonesToExcelFilePut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionExportCityOfHelsinkiMilestonesToExcelFilePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionExportCityOfHelsinkiMilestonesToExcelFilePut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/StrategyDescription/exportCityOfHelsinkiMilestonesToExcelFile', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionExportToStrategyPut operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionExportToStrategyPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * exportToStrategy
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StrategyExportItemSettings>} body 
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionExportToStrategyPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategyDescriptionExportToStrategyPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionExportToStrategyPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionExportToStrategyPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategyDescription/exportToStrategy', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionGenerateBusinessReviewPdfPut operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionGenerateBusinessReviewPdfPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateBusinessReviewPdf
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategyBusinessReviewExportSettings} body 
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionGenerateBusinessReviewPdfPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.strategyDescriptionGenerateBusinessReviewPdfPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionGenerateBusinessReviewPdfPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionGenerateBusinessReviewPdfPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/StrategyDescription/generateBusinessReviewPdf', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionGenerateExcelPut operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionGenerateExcelPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateExcel
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategyExecutionExportSettings} body 
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionGenerateExcelPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.strategyDescriptionGenerateExcelPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionGenerateExcelPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionGenerateExcelPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/StrategyDescription/generateExcel', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionGenerateStrategyMapPdfPut operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionGenerateStrategyMapPdfPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateStrategyMapPdf
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/String>} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.pageOrientation  (default to 0)
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionGenerateStrategyMapPdfPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.strategyDescriptionGenerateStrategyMapPdfPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionGenerateStrategyMapPdfPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionGenerateStrategyMapPdfPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageOrientation': opts['pageOrientation']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/StrategyDescription/generateStrategyMapPdf', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionLoadAllGet operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StrategyDescriptionReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.includeDataActuals  (default to 0)
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StrategyDescriptionReport>}
     */
    this.strategyDescriptionLoadAllGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'includeDataActuals': opts['includeDataActuals']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StrategyDescriptionReport];

      return this.apiClient.callApi(
        '/StrategyDescription/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionLoadGet operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StrategyDescriptionReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StrategyDescriptionReport}
     */
    this.strategyDescriptionLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling strategyDescriptionLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StrategyDescriptionReport;

      return this.apiClient.callApi(
        '/StrategyDescription/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionPublishAutomaticallyGet operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionPublishAutomaticallyGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StrategyDescriptionReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * publishAutomatically
     * @param {String} _4SAPIAppID 
     * @param {Integer} strategyDescriptionID 
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionPublishAutomaticallyGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StrategyDescriptionReport}
     */
    this.strategyDescriptionPublishAutomaticallyGet = function(_4SAPIAppID, strategyDescriptionID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionPublishAutomaticallyGet";
      }

      // verify the required parameter 'strategyDescriptionID' is set
      if (strategyDescriptionID == undefined || strategyDescriptionID == null) {
        throw "Missing the required parameter 'strategyDescriptionID' when calling strategyDescriptionPublishAutomaticallyGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'strategyDescriptionID': strategyDescriptionID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StrategyDescriptionReport;

      return this.apiClient.callApi(
        '/StrategyDescription/publishAutomatically', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionPublishPut operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionPublishPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StrategyDescriptionReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * publish
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StrategicGoalMilestone>} body 
     * @param {Integer} strategyDescriptionID 
     * @param {String} message 
     * @param {Object} opts Optional parameters
     * @param {String} opts.recipientUserIDs  (default to )
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionPublishPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StrategyDescriptionReport}
     */
    this.strategyDescriptionPublishPut = function(_4SAPIAppID, body, strategyDescriptionID, message, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionPublishPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionPublishPut";
      }

      // verify the required parameter 'strategyDescriptionID' is set
      if (strategyDescriptionID == undefined || strategyDescriptionID == null) {
        throw "Missing the required parameter 'strategyDescriptionID' when calling strategyDescriptionPublishPut";
      }

      // verify the required parameter 'message' is set
      if (message == undefined || message == null) {
        throw "Missing the required parameter 'message' when calling strategyDescriptionPublishPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'strategyDescriptionID': strategyDescriptionID,
        'message': message,
        'recipientUserIDs': opts['recipientUserIDs']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StrategyDescriptionReport;

      return this.apiClient.callApi(
        '/StrategyDescription/publish', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionSetGoalDefaultCustomLabelGet operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionSetGoalDefaultCustomLabelGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setGoalDefaultCustomLabel
     * @param {String} _4SAPIAppID 
     * @param {Integer} strategyID 
     * @param {String} customLabel 
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionSetGoalDefaultCustomLabelGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategyDescriptionSetGoalDefaultCustomLabelGet = function(_4SAPIAppID, strategyID, customLabel, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionSetGoalDefaultCustomLabelGet";
      }

      // verify the required parameter 'strategyID' is set
      if (strategyID == undefined || strategyID == null) {
        throw "Missing the required parameter 'strategyID' when calling strategyDescriptionSetGoalDefaultCustomLabelGet";
      }

      // verify the required parameter 'customLabel' is set
      if (customLabel == undefined || customLabel == null) {
        throw "Missing the required parameter 'customLabel' when calling strategyDescriptionSetGoalDefaultCustomLabelGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'strategyID': strategyID,
        'customLabel': customLabel
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategyDescription/setGoalDefaultCustomLabel', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionSetStatusGet operation.
     * @callback module:api/StrategyDescriptionApi~strategyDescriptionSetStatusGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setStatus
     * @param {String} _4SAPIAppID 
     * @param {Integer} strategyID 
     * @param {Integer} statusID 
     * @param {module:api/StrategyDescriptionApi~strategyDescriptionSetStatusGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategyDescriptionSetStatusGet = function(_4SAPIAppID, strategyID, statusID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionSetStatusGet";
      }

      // verify the required parameter 'strategyID' is set
      if (strategyID == undefined || strategyID == null) {
        throw "Missing the required parameter 'strategyID' when calling strategyDescriptionSetStatusGet";
      }

      // verify the required parameter 'statusID' is set
      if (statusID == undefined || statusID == null) {
        throw "Missing the required parameter 'statusID' when calling strategyDescriptionSetStatusGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'strategyID': strategyID,
        'statusID': statusID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategyDescription/setStatus', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
